// extracted by mini-css-extract-plugin
export default {"finish-task":"FinishTask_finish-task__k5Vvb","finish-task-header":"FinishTask_finish-task-header__Rl8O+"};